export default __webpack_public_path__ + "static/news-bg-8529d1fa7d857e1042363cb510b4029b.png";